import { createApiClient } from '@daater/api';
import { getApiUrl } from '@daater/shared';
import { getAuthToken } from './auth-store';

const baseUrl = getApiUrl();

export const apiClient = createApiClient({
  baseUrl,
  getToken: () => getAuthToken(),
});
